// @flow
import Joueur from 'components/joueur/Joueur';
import { connect } from 'react-redux';

import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/joueur/Joueur';
import { fetchJoueur } from 'actions/joueurActions';

export default connect(
  (state: StateType): StateProps => ({
    joueur: state.joueurState.joueur,
    status: state.joueurState.status
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchJoueur: (slug: string) => dispatch(fetchJoueur(slug))
  })
)(Joueur);
